import React, {Fragment, useState} from "react";
import {Image, Modal} from "semantic-ui-react";
import TinySlider from "tiny-slider-react";

const path = 'https://br.inbh.com.br/files/images/name/';

const ModalImage = props => {

    return (
        <Modal
            basic
            size='small'
            open={props.open}
            onClose={props.onClose}
            closeIcon
        >
            <Modal.Content>
                {props.children}
            </Modal.Content>
        </Modal>
    )

};

export const Images = props => {

    const [modal, setModal] = useState(false);
    const [image, setImage] = useState(null);

    const openModal = (image) => {
        setImage(image);
        setModal(true);
    };

    const images = props.images ? props.images : [];

    const settings = {
        lazyload: true,
        nav: true,
        navPosition: 'bottom',
        controls: false,
        mouseDrag: true,
        loop: false,
        items: 2,
        responsive: {
            420: {
                items: 3
            }
        }
    };

    return (
        <Fragment
            // className={'full-container'}
            // style={{
            //     width: "100%",
            //     position: "relative"
            // }}
        >
            <ModalImage
                open={modal}
                onClose={() => setModal(false)}
            >
                <Image src={image} style={{maxHeight: 720}}/>
            </ModalImage>
            <TinySlider settings={settings}>
                {
                    images.map((image) => {

                        const src = path + image.name;
                        const small = src.replace('big', 'small');

                        return (
                            <div style={{cursor: "pointer"}} key={`image-${image.id}`}>
                                <a title={""} onClick={() => openModal(src)}>
                                    <Image src={small} alt={""} height={132} />
                                </a>
                            </div>
                        );
                    })
                }
            </TinySlider>
        </Fragment>
    );
};
